import React, { useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Stack, TextField, Typography } from "@mui/material";
import { useActionHook } from "hooks";
import { useDealActions } from "store";
import { IAssetClass } from "store/types";

interface Props {
  onSubmit: (assetClass: IAssetClass) => void;
  onCancel: () => void;
  initialValue?: string;
  parentId: number;
}

export const CreateSubAssetClass: React.FC<Props> = ({ onSubmit, onCancel, initialValue = "", parentId }) => {
  const [name, setName] = useState<string>(initialValue);
  const { createAssetClassesAction } = useDealActions();

  const {
    action: createSubAssetClass,
    error,
    setError
  } = useActionHook(createAssetClassesAction, {
    onSuccess: (data) => {
      onSubmit(data);
    }
  });

  const handleSubmit = async () => {
    try {
      await createSubAssetClass({ name, parent_id: parentId });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Stack
      sx={{
        position: "absolute" as "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        outline: "none",
        width: 460,
        bgcolor: "white",
        p: "32px",
        gap: "20px",
        boxShadow:
          "0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
        borderRadius: "8px"
      }}
    >
      <Stack
        sx={{ flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #DBE8F5", pb: "6px" }}
      >
        <Typography sx={{ color: "#071F35", fontSize: "18px", lineHeight: "24px", fontWeight: 400 }}>
          Add Sub Asset Class
        </Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <TextField
        label="Sub Asset Class Name"
        value={name}
        error={Boolean(error)}
        helperText={error?.errors?.name?.[0]}
        onChange={(e) => {
          setName(e.target.value);
          if (error) {
            setError(null);
          }
        }}
      />
      <Stack sx={{ flexDirection: "row", gap: "12px", justifyContent: "flex-end" }}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button disabled={Boolean(error) || !name} variant="contained" startIcon={<AddIcon />} onClick={handleSubmit}>
          Add
        </Button>
      </Stack>
    </Stack>
  );
};
